export default __webpack_public_path__ + "static/media/login-cross.ee4d8941.svg";